const serverApp = 'rmbf-bbc';

export const environment = {
  serverApp: serverApp,
  production: true,
  apiBaseUrl: `https://staging.khushinfotech.com/${serverApp}`,
  wsUrl: `wss://staging.khushinfotech.com/${serverApp}/ws`,
  orgUrl: 'https://www.rmbfbbc.org/',
  codatronUrl: 'https://www.codatron.in/',
  erpLogoUrl: 'assets/images/rmbf-logo.png',
  erpFaviconUrl: 'assets/images/Default-favicon.png',
  erpLoadingUrl: 'assets/images/loading.gif',
  erpUserDefaultUrl: 'assets/images/user-default.png',
  codatronLogoUrl: 'assets/images/Codatron.png',
  noImageUrl: 'assets/images/No_Image_Available.png',
  tempImageUrl: 'https://www.rmbfbbc.org/',
  pageAccessErrorMsg: 'You are not authorized to view this page.',
  actionAccessErrorMsg: 'You are not authorized to perform this action.',
  showCode: false,
  showCostDistribution: false,
  useWebSocket: false,
  turnstileSitekey: "0x4AAAAAAExRefQSvSgHCDRm",
  kiIndustryType: {},
  defaultLoginMode: 'email' as 'email' | 'mobile' | 'loginId',
  defaultCountryCode: 'IN',
  // Per-client brand colour (SAAS). Empty = default brand. A hex here re-themes the whole app at
  // runtime via BrandThemeService (applied in main.ts before bootstrap). Phase 4: feed per-tenant.
  brandColor: ''
};
